export enum Role {
  Admin = 'Admin',
  Staff = 'Staff',
  SuperAdmin = 'SuperAdmin',
  Business = 'Business',
}
